/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { MenusBehaviourTypes } from 'store/modules/menus_behaviour_store/types';
import { Container } from './styles';

interface BannerChatbotProps {
  show?: boolean;
  onClose?: () => void;
}

const BannerChatbotModal = ({ show, onClose }: BannerChatbotProps) => {
  const [internalShow, setInternalShow] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal size="lg" show={shouldShow} onHide={handleClose}>
      <Container>
        <div className="modal-body modal-chatbot m-3">
          <button aria-label="Close" className="close" onClick={handleClose} type="button">
            <span aria-hidden="true">×</span>
          </button>
          <h3 className="mb-4">
            Esclareça suas dúvidas sobre <br /> licitações e contratos com o <br /> Novo Consultor
            Jurídico
          </h3>
          <div className="row">
            <div className="col-12 col-md-6 font-scale">
              <p className="pb-3">
                A nova versão foi desenvolvida a partir do vasto acervo do Grupo ConLicitação,
                resultado de 25 anos de experiência no mercado. São materiais cuidadosamente
                selecionados por consultores jurídicos que vivem o dia-a-dia das licitações.
              </p>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  handleClose();
                  dispatch({ type: MenusBehaviourTypes.OPEN_CHATBOT_ASSISTANT });
                }}
              >
                Usar o Consultor Jurídico 2.0
              </button>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default BannerChatbotModal;
